export const resetPasswordGuideMarkdown = `
# Reset Password

Use **Reset Password** when you already have a VetNebula account and know your email address, but forgot your password or need to set a new one.

---

## 1. Start the reset request

1. Go to the VetNebula sign-in page.
2. Click **Reset Password** (red button at the bottom of the form).

![Sign-in page with Reset Password button](/images/guides/reset-password/01-sign-in.png)

---

## 2. Enter your email

1. On the Reset Password page, enter the email address linked to your VetNebula account.
2. Click **Submit**.

![Reset Password request form](/images/guides/reset-password/02-reset-request.png)

You should see a confirmation that instructions were sent to your email.

---

## 3. Open the email and follow the link

Check your **inbox** and **spam/junk** folder for an email from VetNebula with password reset instructions.

The email contains a link that opens VetNebula and takes you to the page where you set a new password. Click that link — do not share it with anyone.

---

## 4. Choose a new password

1. Enter your new password.
2. Enter the same password again in **Repeat password**.
3. Click **Submit**.

![Set your new password](/images/guides/reset-password/03-new-password.png)

After your password is updated, return to the sign-in page and sign in with your email and new password.

---

## Troubleshooting

- **Invalid email** — Make sure you are using the same email address on your VetNebula account. If you were invited as a coach with a \`+coach\` alias, use that address.
- **No reset email** — Wait a few minutes and check spam. You can submit the form again if needed.
- **Invalid or expired code** — Reset links expire after a period of time. Start over from **Reset Password** on the sign-in page and request a new email.
- **Still cannot sign in** — Try **Find My Account** if you never finished setting up your account, or **Send A Login Code** to sign in without a password.

---

## Quick reference

1. Sign in page → **Reset Password**
2. Enter email → check inbox
3. Click link in email → set new password
4. Sign in with your new password
`;
